"use strict";

import $ from "jquery";
/**
 * Simply toggles parameter show/hide
 * @return {[undefined]}       [nothing returned]
 */

function parentSizeWithOutPadding(elm) {
    return (
        elm.outerHeight() -
        parseInt(elm.css("padding-top"), 10) -
        parseInt(elm.css("padding-bottom"), 10)
    );
}

function parentSizeWithOutTopPadding(elm) {
    return elm.outerHeight() - parseInt(elm.css("padding-top"), 10) - 15;
}

export default function openHours() {
    const openInfo = $(".contact-module__opening-hours");

    $(window).resize(function () {
        openInfo.each(function () {
            if (!$(this).is(":visible")) {
                $(this).css(
                    "margin-top",
                    parentSizeWithOutTopPadding(
                        $(this).parents(".contact-module__col"),
                    ) * -1,
                );
            }
        });
    });

    openInfo.each(function () {
        const vm = $(this);
        if (
            vm.parents(".contact-module__col").outerHeight() > vm.outerHeight()
        ) {
            vm.height(
                parentSizeWithOutPadding(vm.parents(".contact-module__col")),
            );
        }

        vm.css(
            "margin-top",
            parentSizeWithOutTopPadding(vm.parents(".contact-module__col")) *
                -1,
        );
    });
}
